const sanitizeString = (string: string) => string.replace(/(\.\.\/)/g, "");

export default sanitizeString;
